import { useQuery } from "@tanstack/react-query";
import { ACTIVITY_TABLE_ID, type ActivityResponse } from "@salesboard/contracts";
import { api, toQueryString } from "@/lib/api";

/**
 * The company-wide feed.
 *
 * The query key's root is `activity`, which is the root **every** SSE entity invalidates —
 * see `SSE_ENTITY_QUERY_ROOT`. So any committed change anywhere re-reads this page, which is
 * what a view called "what is happening" has to do in a product with no refresh button.
 */
export function useActivity(params: Record<string, string | number | undefined>) {
  return useQuery({
    queryKey: [ACTIVITY_TABLE_ID, params],
    queryFn: () => api.get<ActivityResponse>(`/activity${toQueryString(params)}`),
  });
}
